import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {FaturasModel} from "./faturas.model";
import {FaturasService} from "./faturas.service";
import {LoginService} from "../login/login.service";
import {BancosModel} from "../bancos/bancos.model";
import {BancosService} from "../bancos/bancos.service";
import {FichasService} from "../fichas/fichas.service";

import { ConfiguracoesService } from "../configuracoes/configuracoes.service";

declare let $, swal: any;

@Component({
  selector: 'app-visualizar-fatura',
  templateUrl: './visualizar-fatura.component.html'
})
export class VisualizarFaturaComponent implements OnInit {

  title: string;
  fatura: FaturasModel = new FaturasModel();
  banco: BancosModel = new BancosModel();
  preliminares = [];
  logoPdfUrl: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private faturasService: FaturasService,
    private bancosService: BancosService,
    private fichasService: FichasService,
    public loginService: LoginService,
    private _location: Location,
    public func: Funcoes,
    public global: Global,
    private configService: ConfiguracoesService
  ) {

  }

  ngOnInit() {
    this.carregarConfiguracoes();

    let id = this.route.params.subscribe(params => {
      let id = params['id_fatura'];

      this.title = this.func.traduzir('front.visualizarFatura');

      if (!id) {
        return;
      }

      this.faturasService.getById(id, ["cliente", "banco", "moeda", "unidade"])
        .subscribe(
          json => {

            this.fatura = json.Payload[0];

            this.bancosService.getById(json.Payload[0].cliente.id_banco)
              .subscribe(
                json => {

                  this.banco = json.Payload[0];

                  if(this.global.debug == true){
                    console.log(json.Payload[0]);
                  }
                },
                error => {
                  this.func.showErro(error.json());
                });

            this.fichasService.get(null, {"id_fatura":id})
              .subscribe(
                json => {

                  let list = json.Payload || [];
                  list.sort((a: any, b: any) => (a.container || '').localeCompare(b.container || ''));
                  let containersVistos = new Set<string>();
                  list.forEach((item: any) => {
                    let c = (item.container || '').trim();
                    if (c === '') {
                      item.valor_item = (this.fatura && this.fatura.cliente) ? this.fatura.cliente.valor_preliminares : 0;
                    } else {
                      if (!containersVistos.has(c)) {
                        containersVistos.add(c);
                        item.valor_item = (this.fatura && this.fatura.cliente) ? this.fatura.cliente.valor_preliminares : 0;
                      } else {
                        item.valor_item = 0;
                      }
                    }
                  });
                  this.preliminares = list;

                  if(this.global.debug == true){
                    console.log(json.Payload);
                  }
                },
                error => {
                  this.func.showErro(error.json());
                });


            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }



  voltar() {
    this._location.back();
  }

  carregarConfiguracoes() {
    this.configService.getConfiguracoes().subscribe(
      (json: any) => {
        if (json && json.Payload && json.Payload.length > 0) {
          let item = Array.isArray(json.Payload[0]) ? json.Payload[0][0] : json.Payload[0];
          if (item && item.logo_pdf) {
            this.logoPdfUrl = item.logo_pdf.startsWith('http') ? item.logo_pdf : this.global.dominio_site + item.logo_pdf;
          }
        }
      },
      error => {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/faturas/visualizar-fatura.component.ts